<!-- qrCode -->
<template>
  <div class="qrCode">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="公众号二维码：" size="zdy4" prop="qrCodeId">
        <div style="position: relative; overflow: hidden;">
          <div class="clearfix zdy_img magCover" style="float:left">
            <img class="fl" :src="qrCodeSrc" alt />
            <!-- 删除按钮 -->
            <div v-if="hasImage" class="delete-btn" @click="handleDeleteImage">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <el-upload :action="UploadPictureStream" name="file" :show-file-list="false" accept=".png,.jpg,.jpeg" class="upload-demo upload-cover" :auto-upload="true" :on-success="handleQrCodeSuccess">
            <el-button class="postion2" size="small" type="primary">上传图片</el-button>
          </el-upload>
          <div slot="tip" class="el-upload__tip">格式支持：jpg、png、jpeg<span class="betterSize">尺寸推荐：156*231</span></div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { GetPictureStream, UploadPictureStream } from '@/api/configManage'
export default {
  name: 'qrCode',
  data() {
    return {
      UploadPictureStream: UploadPictureStream,
      GetPictureStream: GetPictureStream,
      morImg: require('@/assets/img/img_default.png'),
      qrCodeCover: ''
    }
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {
    // 二维码图片
    qrCodeSrc() {
      return this.qrCodeCover ? this.qrCodeCover : this.ruleForm.qrCodeId ? `${this.GetPictureStream}?pictureId=${this.ruleForm.qrCodeId}` : this.morImg
    },
    // 是否有图片
    hasImage() {
      return this.qrCodeCover || this.ruleForm.qrCodeId
    }
  },
  mounted() {},
  methods: {
    // 成功二维码封面
    handleQrCodeSuccess(res, file) {
      const { data } = res
      const { ID } = data
      this.qrCodeCover = URL.createObjectURL(file.raw)
      this.$set(this.ruleForm, 'qrCodeId', ID)
    },
    // 删除图片
    handleDeleteImage() {
      this.qrCodeCover = ''
      this.$set(this.ruleForm, 'qrCodeId', '')
      this.$message.success('移除成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.qrCode {
  .zdy_img {
    min-height: 100px;
    border: 1px solid #ddd;
    background: #f4f4f4;
    overflow: hidden;
    position: relative;
    height: 231px;
    width: 156px;
    img {
      height: auto;
      max-height: 100%;
      max-width: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    // 删除按钮样式
    .delete-btn {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 24px;
      height: 24px;
      background: rgba(0, 0, 0, 0.22);
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      z-index: 10;

      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }

      i {
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .el-upload__tip {
    float: left;
    padding-left: 20px;
    color: #999;
    font-size: 14px;
  }
  .upload-cover {
    .postion2 {
      height: 231px;
      width: 156px;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }
}
</style>
